import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Metrics from 'services/metrics';
import { converter } from 'helpers/converter';
import { parseDateNew } from 'utils/Dates';
import WithApa from 'newComponents/WithApa/WithApa';
import { TextInput } from 'newComponents/Form';
import Typography from 'newComponents/Typography';
import Button from 'newComponents/Button';
import { useForm } from 'react-hook-form';
import './Device.scss';

const Device = ({
  device,
  // selected,X
  // onSelect,
  // showCheckbox,
  translations,
  onSubmit,
  onDelete,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const { register, handleSubmit, errors } = useForm({
    defaultValues: { deviceName: device.device_name },
  });
  const initRender = useRef(true);

  // const handleToggle = () => {
  //   onSelect(device);
  // };

  useEffect(
    () => {
      if (!initRender.current) {
        let label = 'Editar';
        if (!isEditMode) label = 'Editar - Cancelar';
        Metrics.newEvent({
          eventCategory: 'Dispositivos',
          eventAction: device.device_category,
          eventLabel: label,
        });
      } else {
        initRender.current = false;
      }
    },
    [isEditMode],
  );

  const getDeviceIcon = deviceCategory =>
    `https://www.clarovideo.com/webclient/sk_core/images/registro_device_${deviceCategory}.png`;
  return (
    <>
      <form className="device">
        <img
          className="deviceIcon"
          src={getDeviceIcon(device.device_category)}
          alt="Device"
        />
        {isEditMode ? (
          <TextInput
            id="deviceName"
            name="deviceName"
            className="deviceNameInput"
            ref={register({
              required: converter.convertApa(
                translations,
                'profile_empty_field',
              ),
            })}
            error={errors.deviceName?.message}
          />
        ) : (
          <Typography element="span" className="deviceName">
            {device.device_name}
          </Typography>
        )}
        <Typography element="span" className="deviceType">
          {device.device_type}
        </Typography>
        <Typography element="span" className="deviceDate">
          {parseDateNew(device.date_since)}
        </Typography>
        {isEditMode ? (
          <>
            <Button
              classes={['saveButton']}
              color="primary"
              onClick={handleSubmit(values => {
                initRender.current = true;
                setIsEditMode(false);
                onSubmit({
                  deviceId: device.device_id,
                  purchaseId: device.purchase_id,
                  deviceCategory: device.device_category,
                  ...values,
                });
              })}
            >
              {converter.convertApa(translations, 'profile_button_save')}
            </Button>
            <Button
              classes={['cancelButton']}
              color="secondary"
              onClick={() => {
                setIsEditMode(false);
              }}
            >
              {converter.convertApa(translations, 'profile_button_cancel')}
            </Button>
          </>
        ) : (
          <Button
            classes={['editButton']}
            color="primary"
            onClick={() => {
              setIsEditMode(true);
            }}
          >
            {converter.convertApa(
              translations,
              'profile_my_devices_button_edit_text',
            )}
          </Button>
        )}
        {!isEditMode && (
          <Button
            classes={['deleteButton']}
            color="secondary"
            onClick={() => {
              onDelete(device);
            }}
          >
            <i className="fa fa-trash-o" />
          </Button>
        )}
        {/* {showCheckbox && <Checkbox onChange={handleToggle} value={selected} />} */}
      </form>
    </>
  );
};

Device.propTypes = {
  device: PropTypes.shape({
    device_type: PropTypes.string,
    device_name: PropTypes.string,
    device_id: PropTypes.string,
    date_since: PropTypes.string,
    device_model: PropTypes.string,
    purchase_id: PropTypes.string,
    user_device_id: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  translations: PropTypes.object,
  showCheckbox: PropTypes.bool,
};

export default WithApa(Device);
